import { render } from "./Toastify.vue?vue&type=template&id=4ae03bd3"
import script from "./Toastify.vue?vue&type=script&lang=js"
export * from "./Toastify.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__